<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.polType }}</v-subheader>
        <div class="queryValue" v-for="item in filterPolicyTypeList" :key="item.label">{{ item.label }}</div>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.polNo }}</v-subheader>
        <span class="queryValue">{{ objData.polNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.commDate }}</v-subheader>
        <span class="queryValue">{{ objData.commDate }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.coverNoteNo }}</v-subheader>
        <span class="queryValue">{{ objData.coverNoteNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.premium }}</v-subheader>
        <span class="queryValue">{{ objData.premium }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.premiumGST }}</v-subheader>
        <span class="queryValue">{{ objData.premiumGST }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.commission }}</v-subheader>
        <span class="queryValue">{{ objData.commission }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.commissionGST }}</v-subheader>
        <span class="queryValue">{{ objData.commissionGST }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.commissionGSTStatRate }}</v-subheader>
        <span class="queryValue">{{ objData.commissionGSTStatRate }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.commissionStatus }}</v-subheader>
        <span class="queryValue">{{ objData.commissionStatus }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.fee }}</v-subheader>
        <span class="queryValue">{{ objData.fee }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.stamp }}</v-subheader>
        <span class="queryValue">{{ objData.stamp }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.tax }}</v-subheader>
        <span class="queryValue">{{ objData.tax }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.vehicleRegNo }}</v-subheader>
        <span class="queryValue">{{ objData.vehicleRegNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.insuredRef }}</v-subheader>
        <span class="queryValue">{{ objData.insuredRef }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.insuredName }}</v-subheader>
        <span class="queryValue">{{ objData.insuredName }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.cessionNo }}</v-subheader>
        <span class="queryValue">{{ objData.cessionNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.cessionEndtNo }}</v-subheader>
        <span class="queryValue">{{ objData.cessionEndtNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.cedant }}</v-subheader>
        <span class="queryValue">{{ objData.cedant }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.cessionPolNo }}</v-subheader>
        <span class="queryValue">{{ objData.cessionPolNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.cedantCessionNo }}</v-subheader>
        <span class="queryValue">{{ objData.cedantCessionNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.claimNo }}</v-subheader>
        <span class="queryValue">{{ objData.claimNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.claimAmt }}</v-subheader>
        <span class="queryValue">{{ objData.claimAmt }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ policyDetLabel.claimGST }}</v-subheader>
        <span class="queryValue">{{ objData.claimGST }}</span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      policyDetLabel: {
        polType: 'Policy Type',
        polNo: 'Policy No',
        commDate: 'Commencement Date',
        coverNoteNo: 'Cover Note No.',
        premium: 'Premium',
        premiumGST: 'Premium GST',
        commission: 'Commission',
        commissionGST: 'Commission GST',
        commissionGSTStatRate: 'Commission GST Status, Rate',
        commissionStatus: 'Commission Status',
        fee: 'Fee',
        stamp: 'Stamp',
        tax: 'Tax',
        vehicleRegNo: 'Vehicle Registration No.',
        insuredRef: 'Insured Reference',
        insuredName: 'Insured Name',
        cessionNo: 'Cession No.',
        cessionEndtNo: 'Cession Endt No.',
        cedant: 'Cedant',
        cessionPolNo: 'Cession Policy No.',
        cedantCessionNo: 'Cedant Cession No.',
        claimNo: 'Claim No.',
        claimAmt: 'Claim Amount',
        claimGST: 'Claim GST'
      }
    }
  },
  mounted() {},
  methods: {},
  computed: {
    filterPolicyTypeList() {
      return this.policytypes.filter((list) => {
        return list.value === this.objData.polType
      })
    }
  },
  props: {
    objData: {
      type: Object,
      default: null
    },
    policytypes: {
      type: Array,
      default: null
    }
  }
}
</script>
